<template>
  <div v-if="!job.length && !this.loader" class="job grid-12 g10-s">
    <div class="row column-s align-baseline">
      <div class="title grid-12-s row wrap-s">
        <div class="">
          <div class="row">Job <strong style="margin-left: 4px">{{ id }}</strong></div>
          <span v-if="!job.faturavel">NÃO FATURÁVEL</span><br v-if="!job.faturavel">
          <span v-if="job.improdutivo">IMPRODUTIVO</span>
        </div>
        <div class="row controls col-s">
          <Button v-if="job.improdutivo" layout="green-go" @click="produtivo" :loader="loaderNF">PRODUTIVO</Button>
          <Button v-if="!job.faturavel" layout="green-go" @click="faturavel" :loader="loaderNF">FATURÁVEL</Button>
          <Button layout="gold" @click="jobToGD" :loader="loader"
            v-if="job.id_gestor != user.id_funcionario && perfis.indexOf(user.grupo) > -1 && job.status != 'Cancelado' && job.status != 'Fechado'">
            <i class="fa fa-hand-lizard" /> Pegar Job
          </Button>
          <Categorize :job="job" @update="getJob()" />
          <Associate :job="job" @update="getJob()" />

          <Button v-if="['Categorizado', 'Reagendado'].includes(job.status)" layout="green-go" @click="divulgar"
            :loader="buttonLoader"><i class="fa fa-bullhorn" /> Divulgar</Button>
          <Button layout="green-go white" @click="openOrientation" style="height: 35px;width: 150px"><i
              class="fa fa-scroll" /> ORIENTAÇÕES</Button>
          <Button
            v-if="job.status == 'Doutor orientado' && dperfis.indexOf(user.grupo) > -1 && job.forma_atendimento != 'remoto'"
            layout="green-go" style="min-width: 222px" @click="openDeslocation">INICIAR
            DESLOCAMENTO</Button>
          <Button
            v-if="(job.status === 'Doutor em trânsito' || (job.forma_atendimento == 'remoto' && job.status == 'Doutor orientado')) && dperfis.indexOf(user.grupo) > -1"
            layout="blue-go" :disabled="buttonLoader" :loader="buttonLoader" @click="openCheckin"
            style="width: 170px;">FAZER
            CHECK-IN</Button>
          <Button
            v-if="(job.status == 'Doutor no local' || job.status == 'Falha validação') && dperfis.indexOf(user.grupo) > -1"
            layout="green-go" @click="openFinish" :loader="buttonLoader"><i class="fa fa-check" /> ENCERRAR</Button>
          <Validate :job="job" :cb="getJob" />
          <Button
            v-if="(job.status == 'Finalizado' || job.status == 'Fechamento cancelado') && ['Gestor de Operação', 'TI', 'Diretor de Operação', 'Financeiro'].indexOf(user.grupo) > -1"
            layout="green-go" @click="fechamento" :loader="buttonLoader"><i class="fa fa-check" /> FECHAMENTO</Button>

          <Button v-if="job.status == 'Validado com sucesso' && job.id_gestor == user.id_funcionario" layout="green-go"
            @click="modalFinalizacao = { show: true, title: 'Finalização do Job ' + job.id }"><i class="fa fa-check" />
            FINALIZAR</Button>

          <Button v-if="['Fechado', 'Rescindido'].includes(job.status) && ['TI', 'Financeiro'].includes(user.grupo)"
            layout="red-go" @click="cancela_fechamento" :loader="buttonLoader" style="width: 222px;font-size: 12px"><i
              class="fa fa-trash" /> CANCELAR
            FECHAMENTO</Button>
          <Button
            v-if="user.id_funcionario == job.id_gestor && job.status != 'Fechado' && job.status != 'Cancelado' && job.status != 'Rescindido' && perfis.indexOf(user.grupo) > -1"
            layout="red-go"
            @click="modal = { title: `Cancelar Job ${job.id}`, layout: 'JobCancel', show: true, job: job }"
            :loader="buttonLoader"><i class="fa fa-trash" /> CANCELAR</Button>
        </div>
      </div>
      <div class="row align-center justify-end panel-right wrap">
        <div
          v-if='check() && ["Gestor de Operação", "TI", "Diretor de Operação", "Gestor de Registro", "Gestor de Demanda", "Gestor de Associação", "Gestor de Device", "Gestor de Infra"].includes(user.grupo)'
          class="changeGD row align-center">
          <i v-if="showChangeGD" @click="showChangeGD = false" class="fa fa-times text-red pointer"
            style="margin-right: 10px" title="CANCELAR" />
          <select v-if="showChangeGD" class="input grid-2" v-model="job.id_gestor" style="margin-bottom: 12px">
            <option v-for="(g, i) of gds" :key="'gd' + i" :value="g.id">{{ g.nome }}</option>
          </select>
          <Button :loader="loader" :layout="showChangeGD ? 'gray save' : `gray`" @click="changeGD">
            <i class="fa-solid fa-right-left"></i> {{ showChangeGD ? 'Salvar' : 'Mudar GD' }}</Button>
        </div>
        <Button v-if="showMaterial" layout="gray"
          @click="modalMaterial = { show: true, layout: 'Material', title: 'MATERIAIS', job: job }">
          <i class="fa fa-toolbox" /> Materiais
        </Button>
        <Button v-if="!check()" @click="df = { title: 'Detalhamento do Fechamento.', show: true }" layout="gray"><i
            class="fa fa-list" />Detalhar fechamento</Button>
        <Button v-if="check() && job.tipo == 'alocacao' && job.qtd_atendimentos_encerrados > 0"
          @click="resaloc = { title: 'Rescisão de alocação.', show: true }" layout="gray"><i
            class="fa fa-not-equal" />Rescindir
          Alocação</Button>
        <Button @click="remsup = { title: 'Remover Supporter', show: true }"
          v-if="['Com Doutor', 'Doutor orientado', 'Doutor em trânsito', 'Doutor no local', 'Atendimento encerrado', 'Fechamento cancelado', 'Finalizado'].includes(job.status)"
          layout="gray"><i class="fa fa-user-slash" />Remover Supporter</Button>
        <Button @click="candmod = { title: 'Candidatos', show: true }"
          v-if="['Divulgado', 'Reagendado', 'Sem Doutor'].includes(job.status)" layout="gray"><i class="fa fa-users" />
          Candidatos</Button>
        <Button v-if="job.status === 'Doutor no local' || job.status === 'Falha validação'" layout="gray"
          @click="openAttach"><i class="fa fa-paperclip" /> Anexar arquivo</Button>
        <Button layout="gray" @click="openNote">
          <i class="fa fa-book" /> Anotações </Button>
        <Agenda :job="job" />
        <Button v-if='["Categorizado", "Divulgado", "Sem Doutor", "Reagendado",
          "Validado com sucesso", "Com Doutor", "Doutor orientado", "Doutor em trânsito",
          "Doutor no local", "Atendimento encerrado"].includes(job.status)' layout="gray"
          @click="modal = { show: true, title: 'Reagendar Job: ' + job.id, layout: 'Reagendar', job: job, cb: getJob }">
          <i class="fa fa-calendar" /> Reagendar
        </Button>
        <Button layout="gray" @click="openNaoFaturavel">
          <i class="fa fa-not-equal" /> Não faturável
        </Button>
        <Button v-if="!job.improdutivo" layout="gray" @click="openImprodutivo">
          <i class="fa fa-xmark" /> Improdutivo
        </Button>
        <Button layout="gray" @click="openAddValues"> <i class="fa fa-dollar-sign" /> Valores Adicionais</Button>
        <Button layout="gray" @click="modalLancamentos = { show: true, title: 'Lançamentos do Job: ' + job.id }"> <i
            class="fa fa-money-check-dollar" /> Lançamentos</Button>
        <Button layout="gray"
          @click="modal = { title: `Lançamento de KM adicional para supporter`, show: true, layout: 'Km', job: job, close: closeKm }"
          v-if="job.status !== 'Fechado' || job.status !== 'Rescindido' || job.status !== 'Cancelado'"><i
            class="fa fa-road" /> KM Adicionais</Button>
        <Button layout="gray" @click="openAttendance">
          <i class="fa fa-screwdriver-wrench" /> Atendimentos
        </Button>
        <Button layout="gray" @click="() => openHistoric(job.id)">
          <i class="fa fa-list" /> Histórico
        </Button>
        <!-- <div class="status row justify-end grid-6-g grid-7-m hide-s">
          <Button layout="red-go">Reabrir job</Button>
        </div>-->
      </div>
    </div>
    <div class="info row label align-center wrap justify-space">
      <div class="grid-6-s grid-2-g">
        Status
        <br />
        <strong>{{ job.status ? job.status.replace("Doutor", "Supporter") : '' }}</strong>
      </div>
      <div class="grid-6-s grid-1-g">
        Gestor
        <br />
        <strong>{{ job.nome_gestor }}</strong>
      </div>
      <div v-if="job.unidade_negocio" class="grid-6-s grid-2-g">
        Unidade de Negócio
        <br />
        <strong>{{ job.unidade_negocio }}</strong>
      </div>
      <div v-if="job.forma_atendimento" class="grid-6-s grid-2-g">
        Tipo Atendimento
        <br />
        <strong>{{ job.forma_atendimento }}</strong>
      </div>
      <div v-if="job.forma_atendimento" class="grid-6-s grid-2-g">
        Tipo Serviço
        <br />
        <strong>{{ job.tipo_servico }}</strong>
      </div>
      <div class="grid-6-s grid-2-g">
        Abertura
        <br />
        <strong>{{ new Date(job.criado_em).toLocaleString() }}</strong>
      </div>
      <div class="grid-6-s grid-2-g">
        Agendado para
        <br />
        <strong>{{ new Date(job.dh_agendamento_cliente).toLocaleString() }}</strong>
      </div>
      <div class="grid-6-s grid-2-g">
        Urgência
        <br />
        <strong>{{ job.urgencia_atendimento }}</strong>
      </div>
      <div class="grid-6-s grid-2-g" v-if="job.duracao_atendimento">
        Duração atendimento
        <br />
        <strong>{{ job.duracao_atendimento }}</strong>
      </div>
      <div class="grid-6-s grid-2-g" v-if="job.duracao_folga">
        Duração folga
        <br />
        <strong>{{ job.duracao_folga }}</strong>
      </div>
      <div class="grid-6-s grid-2-g" v-if="job.codigo_chamado_cliente">
        Código Cliente
        <br />
        <strong>{{ job.codigo_chamado_cliente }}</strong>
      </div>
      <div class="grid-6-s grid-2-g">
        Cliente
        <br />
        <strong>{{ job.nome_cliente }}</strong>
      </div>
      <div class="grid-6-s grid-2-g">
        Responsável cliente
        <br />
        <strong>{{ job.nome_responsavel_cliente }}</strong>
      </div>
      <div class="grid-6-s grid-2-g" v-if="job.cliente_cliente">
        Cliente do cliente
        <br />
        <strong>{{ job.cliente_cliente }}</strong>
      </div>
      <div class="grid-6-s grid-2-g" v-if="job.nome_orientacao">
        Orientação
        <br />
        <strong>{{ job.nome_orientacao }}</strong>
      </div>
      <div class="grid-6-s grid-2-g">
        Candidatos
        <br />
        <strong>{{ job.candidatos_job ? job.candidatos_job.length : 0 }}</strong>
      </div>
      <div class="grid-6-s grid-2-g">
        Valor do Job
        <br />
        <strong>{{ job.valor_job | money }}</strong>
      </div>
      <div class="grid-6-s grid-2-g">
        Valor Hora Extra
        <br />
        <strong>{{ job.valor_hora_extra | money }}</strong>
      </div>
    </div>
    <div class="info column label" v-if="job.id_atendimento_atual" style="padding-top:40px">
      <div class="sla row">Supporter
        <div class="row" style="margin-left:20px;margin-top:-4px" v-if="supporters && supporters.length > 0">
          <select class="input" v-model="job.id_agregado_doutor" v-if="!job.id_agregado_doutor || !resume">
            <option :value="null">Delegar equipe técnico</option>
            <option v-for="(aggregate, i) of supporters.filter((r) => r.status == 'ativo')" :key="'aggregate' + i"
              :value="aggregate.id">{{ aggregate.nome }}</option>
          </select>
          <Button :loader="buttonLoader" layout="green-go" @click="setAggregate"
            v-if="!resume && job.id_agregado_doutor">Delegar</Button>
          <div class="row ac">
            <b v-if="resume" style="color: #444"> {{ delegateName }}</b>
            <Button :loader="buttonLoader" layout="red-go" @click="removeAggregate" v-if="resume">Revogar
              delegação</Button>
          </div>
        </div>
      </div>
      <div class="row wrap justify-space label align-center">
        <div class="grid-12-s grid-4-m grid-2-g row perfil align-center justify-center-s margin-bottom">
          <div>
            <img :src="job.foto_agregado_doutor || job.foto_doutor"
              v-if="job.foto_agregado_doutor || job.foto_doutor" />
            <img src="../../../assets/img/usuario_padrao.png" v-else />
          </div>
          <div>
            <b>ID {{ job.id_doutor }}</b><br />
            <strong>{{ delegateName || job.nome_agregado_doutor || job.nome_doutor }}</strong>
          </div>
        </div>

        <div class="grid-12-s grid-7-m grid-2-g comp">
          Competências<br />
          <div class="container">
            <strong v-if="job.competencias_agregado_doutor">{{
              job.competencias_agregado_doutor ? job.competencias_agregado_doutor.join(", ") : "" }}</strong>
            <strong v-else>{{ job.competencias_doutor ? job.competencias_doutor.join(", ") : "" }}</strong>
          </div>
        </div>
        <div class="grid-6-m grid-1-g grid-6-s justify-center margin-bottom">
          Score <br />
          <strong class="font-18 text-green" v-if="job.score_agregado_doutor">
            {{ job.score_agregado_doutor ? job.score_agregado_doutor.toString().replace(".", ",") : "5,00" }}</strong>
          <strong class="font-18 text-green" v-else>
            {{ job.score ? job.score.toString().replace(".", ",") : "5,00" }}</strong>
        </div>
        <div class="grid-6-m grid-1-g grid-6-s justify-center margin-bottom">
          Atendimentos:<br />
          <strong class="font-18 text-green">
            {{ job.atendimentos_agregado_doutor || job.atendimentos_doutor }}</strong>
        </div>
        <div class="grid-6-m grid-1-g grid-6-s justify-center margin-bottom">
          Cadastrado em:<br />
          <strong class="font-18 text-green" v-if="job.cadastro_agregado_doutor">
            {{ job.cadastro_doutor | date }}</strong>
          <strong class="font-18 text-green" v-else>
            {{ job.cadastro_doutor | date }}</strong>
        </div>

        <div class="grid-6 grid-1-g margin-bottom" v-if="user.perfil !== 'cliente'">
          Celular<br />
          <strong>{{ job.celular_doutor | phone }}</strong>
        </div>
        <div class="grid-6-s grid-6-m grid-1-g margin-bottom">
          RG<br />
          <strong>{{ job.rg_agregado_doutor || job.rg_doutor }}</strong>
        </div>
        <div class="grid-6-m grid-12-s grid-2-g margin-bottom" v-if="user.perfil !== 'cliente'">
          E-mail<br />
          <strong>{{ job.email_doutor.toLowerCase() }}</strong>
        </div>
      </div>
    </div>
    <div v-if="job.mapa_campos && job.mapa_campos.length" class="data column label">
      <div class="sla">Campos adicionais</div>
      <div class="row col-s">
        <div class="adicionais g6 g10-s">
          <h3>Registro</h3>
          <div class="row wp">
            <Campo v-for="m of campos_registro" :key="m.nome" :f="m" :v="job[m.nome]" :read="true" />
          </div>
        </div>
        <div class="adicionais g6 g10-s">
          <h3>Encerramento</h3>
          <div class="row wp">
            <Campo v-for="m of campos_encerramento" :key="m.nome" :f="m" :v="job[m.nome]" :read="true" />
          </div>
        </div>
      </div>
    </div>
    <div class="data column label">
      <div class="sla">SLA | Eventos</div>
      <div class="row wrap">
        <div class="sla-item grid-3 grid-6-s">
          Gestor de Demanda<br />
          <div class="sla-content row align-center">
            <JobStatus
              :color="(new Date(job.sla_associacao_gestor) > new Date(job.dh_associacao_gestor)) || new Date(job.sla_associacao_gestor) > new Date() ? 'green' : 'red'" />
            <div class="sla-status">
              <strong>{{ new Date(job.sla_associacao_gestor).toLocaleString() }}</strong><br />
              <strong v-if="job.dh_associacao_gestor">{{ new Date(job.dh_associacao_gestor).toLocaleString() }}</strong>
            </div>
          </div>
        </div>

        <div class="sla-item grid-3 grid-6-s">
          Categorização<br />
          <div class="sla-content row align-center">
            <JobStatus
              :color="(new Date(job.sla_categorizacao) > new Date(job.dh_categorizacao)) || new Date(job.sla_categorizacao) > new Date() ? 'green' : 'red'" />
            <div class="sla-status">
              <strong>{{ new Date(job.sla_categorizacao).toLocaleString() }}</strong><br />
              <strong v-if="job.dh_categorizacao">{{ new Date(job.dh_categorizacao).toLocaleString() }}</strong>
            </div>
          </div>
        </div>

        <div class="sla-item grid-3 grid-6-s">
          Divulgação<br />
          <div class="sla-content row align-center">
            <JobStatus
              :color="(new Date(job.sla_divulgacao) > new Date(job.dh_divulgacao)) || new Date(job.sla_divulgacao) > new Date() ? 'green' : 'red'" />
            <div class="sla-status">
              <strong>{{ new Date(job.sla_divulgacao).toLocaleString() }}</strong><br />
              <strong v-if="job.dh_divulgacao">{{ new Date(job.dh_divulgacao).toLocaleString() }}</strong>
            </div>
          </div>
        </div>

        <div class="sla-item grid-3 grid-6-s">
          Alocação Supporter<br />
          <div class="sla-content row align-center">
            <JobStatus
              :color="(new Date(job.sla_associacao_doutor) > new Date(job.dh_associacao_doutor)) || new Date(job.sla_associacao_doutor) > new Date() ? 'green' : 'red'" />
            <div class="sla-status">
              <strong>{{ new Date(job.sla_associacao_doutor).toLocaleString() }}</strong><br />
              <strong v-if="job.dh_associacao_doutor">{{ new Date(job.dh_associacao_doutor).toLocaleString() }}</strong>
            </div>
          </div>
        </div>

        <div v-if="job.forma_atendimento != 'remoto'" class="sla-item grid-3 grid-6-s">
          Início Deslocamento<br />
          <div class="sla-content row align-center">
            <JobStatus v-if="job.sla_inicio_deslocamento" :color="(job.dh_inicio_deslocamento &&
              new Date(job.sla_inicio_deslocamento) > new Date(job.dh_inicio_deslocamento)) ||
              new Date(job.sla_inicio_deslocamento) > new Date() ? 'green' : 'red'" />
            <div class="sla-status" v-if="job.sla_inicio_deslocamento">
              <strong>{{ new Date(job.sla_inicio_deslocamento).toLocaleString() }}</strong><br />
              <strong v-if="job.dh_inicio_deslocamento">{{
                new Date(job.dh_inicio_deslocamento).toLocaleString()
              }}</strong>
            </div>
          </div>
        </div>
        <div class="sla-item grid-3 grid-6-s">
          Check-in<br />
          <div class="sla-content row align-center">
            <JobStatus v-if="job.sla_checkin" :color="(job.dh_checkin &&
              new Date(job.sla_checkin) > new Date(job.dh_checkin)) ||
              new Date(job.sla_checkin) > new Date() ? 'green' : 'red'" />
            <div class="sla-status" v-if="job.sla_checkin">
              <strong>{{ new Date(job.sla_checkin).toLocaleString() }}</strong><br />
              <strong v-if="job.dh_checkin">{{
                new Date(job.dh_checkin).toLocaleString()
              }}</strong>
            </div>
          </div>
        </div>
        <div class="sla-item grid-3 grid-6-s">
          Fim Atendimento<br />
          <div class="sla-content row align-center">
            <JobStatus v-if="job.sla_encerramento" :color="(job.dh_fechamento &&
              new Date(job.sla_encerramento) > new Date(job.dh_fechamento) >= new Date()) || new Date(job.sla_encerramento) > new Date()
              ? 'green' : 'red'" />
            <div class="sla-status" v-if="job.sla_encerramento">
              <strong>{{ new Date(job.sla_encerramento).toLocaleString() }}</strong><br />
              <strong v-if="job.dh_encerramento">{{ new Date(job.dh_encerramento).toLocaleString() }}</strong>
            </div>
          </div>
        </div>
        <div class="sla-item grid-3 grid-6-s">
          Validação<br />
          <div class="sla-content row align-center">
            <JobStatus
              :color="(new Date(job.sla_validacao) > new Date(job.dh_validacao)) || new Date(job.sla_associacao_doutor) > new Date() ? 'green' : 'red'" />
            <div class="sla-status">
              <strong>{{ new Date(job.sla_validacao).toLocaleString() }}</strong><br />
              <strong v-if="job.dh_validacao">{{ new Date(job.dh_validacao).toLocaleString() }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="job.forma_atendimento != 'remoto'" class="data column label">
      <div class="sla">Local de atendimento</div>
      <div class="row column-s">
        <div class="grid-3 grid-12-s">Local <br /><strong>{{ job.nome_local_atendimento }}</strong></div>
        <div class="grid-3 grid-12-s">Endereço <br /><strong>{{ job.logradouro }}, {{ job.numero }}</strong></div>
        <div class="grid-2-g grid-3-m">Complemento <br /><strong>{{ job.complemento }}</strong></div>
        <div class="grid-2-g grid-3-m">Bairro <br /><strong>{{ job.bairro }}</strong></div>
        <div class="grid-2-g grid-3-m">Cidade/Estado <br /><strong>{{ job.cidade }}/{{ job.estado }}</strong></div>
        <div class="grid-2-g grid-3-m">CEP <br /><strong>{{ job.cep | cep }}</strong></div>
      </div>
    </div>

    <div class="grid-12 column label">
      <div class="row column-s problem">
        <div class="grid-6 grid-12-s column label">
          <label>
            Descrição Problema <i class="fa fa-question-circle font-13 tip">
              <div>Descreva em detalhes o seu problema. Não informe aqui dados sensíveis.</div>
            </i>
          </label>
          <div class="text-font" v-html="job.problema ? job.problema.replace(/\n/g, '<br />') : ''"></div>
        </div>
        <div class="grid-6 grid-12-s column label">
          <br /><label>
            Dados Sensíveis
            <i class="fa fa-question-circle font-13 tip">
              <div>Informe aqui dados sensíveis como contatos, endereços, senhas, nomes, telefones, etc.</div>
            </i>
          </label>
          <div class="text-font" v-if="job.dado_sensivel" v-html="job.dado_sensivel.replace(/\n/g, '<br />')"></div>
        </div>
      </div>
    </div>

    <div class="grid-12 divulgacao">
      <div class="title">Dados de divulgação</div>
      <div class="row grid-12">
        <div class="grid-4 column" v-if="job.criado_em">
          <label>Data e hora divulgação</label>
          {{ job.criado_em | date }}
        </div>
        <div class="grid-4 column" v-if="job.dh_inicio_divulgacao">
          <label> Data e Hora Início Envio</label>
          {{ job.dh_inicio_divulgacao | date }}
        </div>
        <div class="grid-3 column" v-if="job.dh_fim_divulgacao">
          <label> Data e Hora Fim Envio</label>
          {{ job.dh_fim_divulgacao | date }}
        </div>
      </div>

      <div class="row grid-12 numbers">
        <div class="grid-3 column" v-if="job.listados">
          <label>Supporters Encontrados</label>
          {{ job.listados }}
        </div>
        <div class="grid-3 column" v-if="job.enviados">
          <label>Supporters Enviados</label>
          {{ job.enviados | date }}
        </div>
        <div class="grid-3 column" v-if="job.confirmados">
          <label>Entregas confirmadas</label>
          {{ job.confirmados }}
        </div>
        <div class="grid-3 column" v-if="job.falhas">
          <label>Entregas com falha</label>
          {{ job.falhas }}
        </div>
      </div>

      <div v-if="job.nome_criado_por" class="info row wrap column-s justify-around">
        <div class="text-center grid-6 grid-12-s">
          <label>Criado por</label>
          <div>{{ job.nome_criado_por }} em {{ job.criado_em | date }}</div>
        </div>
        <div class="text-center grid-6 grid-12-s" v-if="job.nome_alterado_por">
          <label>Alterado por</label>
          <div>{{ job.nome_alterado_por }} em {{ job.alterado_em | date }}</div>
        </div>
      </div>
    </div>
    <Notes :notes="job.notas" />
    <Modal :modal="modal" />
    <Modal :modal="modalnf">
      <div class="nao-faturavel text-right">
        <textarea v-model="motivo_nao_faturavel"
          placeholder="Motivo para o job não ser faturado para o cliente"></textarea>
        <br /><br /><Button v-if="motivo_nao_faturavel.length" @click="naoFaturavel" :loader="loaderNF"
          layout="green-go">Configurar Job como não faturável</Button>
      </div>
    </Modal>
    <Modal :modal="modalimp">
      <div class="nao-faturavel col">
        <label class="cp">Causa da improdutividade</label>
        <select class="input" v-model="id_flag_improdutivo">
          <option value="null">Selecione</option>
          <option v-for="flag of flags" :key="flag.id" :value="flag.id"> {{ flag.flag }}</option>
        </select>
        <label class="cp" style="margin-top:30px">Motivo improdutivo</label>
        <input v-model="motivo_improdutivo" placeholder="Motivo para o job não ser produtivo." />
        <Button style="margin-top:30px;margin-left:0" v-if="motivo_improdutivo.length && id_flag_improdutivo"
          @click="improdutivo" :loader="loaderNF" layout="green-go">Configurar Job como não Produtivo.</Button>
      </div>
    </Modal>
    <Modal :modal="modalHistoric">
      <Historic :ID="modalHistoric.ID" />
    </Modal>
    <Modal :modal="modalLancamentos">
      <Lancamentos :job="job" />
    </Modal>
    <Modal :modal="candmod">
      <Candidatos :job="job" :cb="() => (getJob(), candmod.show = false)" />
    </Modal>
    <Modal :modal="remsup">
      <RemoveSupporter :job="job" :cb="() => (getJob(), remsup.show = false)" />
    </Modal>
    <Modal :modal="resaloc">
      <div class="resaloc">
        <b>ATENÇÃO!!!!</b> Rescisão de alocação é uma operação irreversível!!! Ela termina uma aloção cancelando os
        atendimentos pendentes. Esta operação irá:<br>
        <br>1) cancelar o atendimento atual zerando qualquer pagamentos para ele. <br>
        2) cancelar todos os agendamentos restantes na alocação. <br>3) fazer o fechamento financeiro do job com base
        nos atendimentos realizados e validados até o momento.<br><br>
        Se o atendimento atual deve ser computado no acerto faça o encerramento e validação dele antes de rescindir a
        alocação. Se o atendimento atual não gerou custos prossiga com a rescisão.
        <br>
        <br><label>Motivo da rescisão da alocação</label><br>
        <input v-model="motivo" placeholder="Motivo da rescisão da alocação" />
        <Button @click="rescindirAloc" :loader="buttonLoader" layout="red-go">RESCINDIR</Button>
      </div>
    </Modal>
    <Modal :modal="df">
      <DetalhaFechamento :job="job"></DetalhaFechamento>
    </Modal>
    <Modal :modal="modalMaterial" />

    <Modal :modal="modalFinalizacao">
      <div class="modalFinalizacao row wp js">
        <div class="g4 g12-s col">
          <label>O Problema foi resolvido?</label>
          <select v-model="finalizacao.aceite_cliente">
            <option :value="false">Não</option>
            <option :value="true">Sim</option>
          </select>
        </div>
        <div class="g7 g12-s col">
          <label>Comprovante de fechamento no cliente:</label>
          <input type="datetime-local" v-model="finalizacao.dh_fechamento_cliente" />
        </div>
        <Button v-if="finalizacao.dh_fechamento_cliente" @click="finalizarJob" layout="green-go">FINALIZAR JOB</Button>
      </div>
    </Modal>

  </div>
  <div v-else class="load grid-12 row align-center justify-center">
    <div v-if="notfound" class="fb tc cr font-22" style="margin-top:20%">Job não encontrado.</div>
    <Loader v-else layout="small" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/components/Loader";
import Button from "@/components/Button";
import Modal from "@/components/Modal";
import Agenda from "@/views/admin/components/Agenda";
import Categorize from "@/views/admin/components/Categorize";
import Historic from "@/views/admin/components/Historic";
import Associate from "@/views/admin/components/Associate";
import Validate from "@/views/admin/components/Validate";
import Lancamentos from "@/views/admin/components/Lancamentos";
import Candidatos from "@/views/admin/components/Candidatos";
import JobStatus from "@/components/JobStatus";
import Notes from "@/components/Notes";
import Router from "@/router";
import RemoveSupporter from "@/views/admin/components/RemoveSupporter";
import DetalhaFechamento from "@/views/admin/components/DetalhaFechamento";
import Campo from "@/components/Campo";
export default {
  name: "Job",
  props: { id: String },
  components: { Campo, Button, Loader, Modal, JobStatus, Notes, Categorize, DetalhaFechamento, RemoveSupporter, Associate, Candidatos, Validate, Historic, Lancamentos, Agenda },
  data() {
    return {
      supporters: [],
      notfound: false,
      resume: false,
      motivo: '',
      resaloc: {},
      df: {},
      finalizacao: { dh_fechamento_cliente: new Date(), aceite_cliente: false },
      loader: true,
      delegateName: '',
      remsup: {},
      buttonLoader: false,
      loaderNF: false,
      job: {},
      orientation: true,
      modal: {},
      modalnf: {},
      modalHistoric: {},
      modalMaterial: {},
      router: Router,
      gds: [],
      flags: [],
      gd: null,
      showChangeGD: false,
      modalFinalizacao: {},
      modalLancamentos: {},
      candmod: {},
      modalimp: {},
      motivo_nao_faturavel: "",
      id_flag_improdutivo: null,
      motivo_improdutivo: "",
      showMaterial: false,
      dperfis: ['Financeiro', 'Gestor de Demanda', 'Gestor de Device', 'Gestor de Infra', 'TI', 'Gestor de Operação', 'Diretor de Operação'],
      perfis: ['Gestor de Demanda', 'Gestor de Registro', 'Gestor de Device', 'Gestor de Infra', 'Gestor de Associação', 'TI', 'Gestor de Operação', 'Diretor de Operação', 'Financeiro']
    };
  },
  methods: {
    ...mapGetters("job", ["GET_JOB"]),
    ...mapActions("job", ["REMOVE_AGGREGATE", "SET_AGGREGATE", "RESCENDIR_ALOC", "DIVULGA", "CANCELA_FECHAMENTO", "IMPRODUTIVO", "NAO_FATURAVEL", "FATURAVEL", "LOAD_JOB", "SET_ORIENTATION", "SET_DESLOCATION", "SET_CHECKIN", "CHANGE_GD"]),
    ...mapActions("admin", ["FLAGS_LIST", "FUNCIONARIO_LIST", "TAKE_JOB", "FINALIZA_JOB", "FINALIZACAO", "MATERIAL_SERVICETYPE", "EQUIPE_ADMIN_LISTA"]),
    async setAggregate() {
      if (this.job.id_agregado_doutor) {
        this.buttonLoader = true;
        await this.SET_AGGREGATE({
          id: this.job.id_agregado_doutor,
          job: this.job.id,
        }).then((r) => {
          if (r.status == 200 || r.status == 201) {
            this.resume = true;
            this.delegateName = this.supporters.filter(
              (r) => r.id == this.job.id_agregado_doutor
            )[0].nome;
          }
        });
        this.buttonLoader = false;
      }
    },
    async removeAggregate() {
      this.buttonLoader = true;
      await this.REMOVE_AGGREGATE(this.job.id).then((r) => {
        if (r.status == 200 || r.status == 201) {
          this.resume = false;
          this.job.id_agregado_doutor = null;
          this.delegateName = ''
        }
      });
      this.buttonLoader = false;
    },
    async divulgar() {
      this.buttonLoader = true;
      await this.DIVULGA(this.job.id);
      this.buttonLoader = false;
      this.getJob();
    },
    async getJob() {
      this.loader = true;
      await this.LOAD_JOB(this.id).then(async r => this.job = r)
      if (!this.job.id) return this.notfound = true
      if (this.job.id_tipo_servico) {
        this.MATERIAL_SERVICETYPE({ t: 'get', id: this.job.id_tipo_servico }).
          then(({ data }) => {
            if (data && data.length) this.showMaterial = true
          })

      }
      if (this.job.id_doutor)
        this.EQUIPE_ADMIN_LISTA(this.job.id_doutor).then((r) => {
          this.supporters = r.data || [];
          if (this.supporters && this.supporters.length && this.job.id_agregado_doutor) {
            this.resume = true;
            this.delegateName = this.supporters.filter(
              (r) => this.job.id_agregado_doutor == r.id
            )[0].nome;
          }
        });
      this.loader = false;
    },
    check() {
      return !["Fechado", "Cancelado", "Rescindido"].includes(this.job.status)
    },
    closeKm() {
      this.modal = { ...this.modal, show: false }
    },
    async rescindirAloc() {
      if (confirm("Deseja rescindir esta alocação?")) {
        this.buttonLoader = true;
        await this.RESCENDIR_ALOC({ id: this.job.id, motivo: this.motivo });
        this.buttonLoader = false;
        this.resaloc.show = false
        this.getJob();
      }
    },
    async cancela_fechamento() {
      if (confirm("Deseja CANCELAR O FECHAMENTO do job?")) {
        this.buttonLoader = true;
        await this.CANCELA_FECHAMENTO(this.job.id);
        this.buttonLoader = false;
        this.getJob();
      }
    },
    openAddValues() {
      this.modal = {
        id: this.id || this.$route.params.id,
        job: this.job,
        show: true,
        title: `Valores Adicionais - JOB ${this.id || this.$route.params.id}`,
        layout: "AddValues",
      };

    },
    async openHistoric(ID) {
      this.modalHistoric = {
        ID: ID,
        title: "Histórico",
        show: true,
      }
    },
    async naoFaturavel() {
      if (confirm("Realmente deseja configurar esse Job como Não Faturável?")) {
        this.loaderNF = true
        await this.NAO_FATURAVEL({ id: this.job.id, motivo_nao_faturavel: this.motivo_nao_faturavel })
        this.loaderNF = false
        this.modalnf.show = false
      }
    },
    async faturavel() {
      this.loaderNF = true
      await this.FATURAVEL(this.job.id)
      this.loaderNF = false
    },
    async produtivo() {
      if (confirm("Deseja configurar esse Job como PRODUTIVO?")) {
        this.loaderNF = true
        await this.IMPRODUTIVO({ id: this.job.id, improdutivo: false, motivo_improdutivo: '', id_flag_improdutivo: null })
        this.loaderNF = false
        this.getJob()
      }
    },
    async improdutivo() {
      if (confirm("Realmente deseja configurar esse Job como IMPRODUTIVO?")) {
        this.loaderNF = true
        await this.IMPRODUTIVO({ id: this.job.id, improdutivo: true, id_flag_improdutivo: this.id_flag_improdutivo, motivo_improdutivo: this.motivo_improdutivo })
        this.loaderNF = false
        this.modalimp.show = false
        this.getJob()
      }
    },
    openImprodutivo() {
      this.FLAGS_LIST({ status: "ativo", filtro: "improdutivo" }).then(({ data }) => (this.flags = data));
      this.modalimp = {
        show: true,
        title: `Job ${this.job.id} - Improdutivo`,
        description: 'Motivo para o job não ser Produtivo.'
      };
    },
    async fechamento() {
      if (confirm("Deseja solicitar o FECHAMENTO do job?")) {
        this.loader = true
        await this.FINALIZA_JOB(this.id)
        setTimeout(async () => await this.getJob(), 3000)
      }
    },
    openFinish() {
      this.modal = {
        id: this.id || this.$route.params.id,
        show: true,
        title: "Encerramento",
        description: "Job " + this.job.id,
        layout: "Finish",
        cb: this.getJob,
        job: this.job
      };
    },
    openNaoFaturavel() {
      this.modalnf = {
        show: true,
        title: `Job J${this.job.id} - Não Faturável`,
        description: 'Motivo para o job não ser faturado para o cliente',
        cb: this.getJob
      };
    },
    async changeGD() {
      if (this.showChangeGD) {
        this.loader = true
        await this.CHANGE_GD({ job: this.job.id, id_gestor: this.job.id_gestor })
        this.getJob()
        this.loader = false
      }
      this.showChangeGD = !this.showChangeGD
    },
    async openCheckin() {
      this.loader = true;
      await this.SET_CHECKIN(this.job.id)
      this.loader = false;
      this.getJob()
    },
    async getGD() {
      this.FUNCIONARIO_LIST({ status: 'ativo', lista_grupo: ["Gestor de Registro", "Gestor de Demanda", "Gestor de Associação", "Gestor de Device", "Gestor de Infra", "Diretor de Operação", "Gestor de Operação"] }).then(({ data }) => this.gds = data)
    },
    async openDeslocation() {
      this.loader = true;
      await this.SET_DESLOCATION(this.job.id)
      this.loader = false;
      this.getJob()
    },
    openOrientation() {
      this.modal = {
        show: true,
        title: "Orientações para o Supporter",
        description: "Job J",
        layout: "Orientation",
        cb: this.getJob,
        job: this.job
      };
    },
    openNote() {
      this.modal = {
        id: this.id || this.$route.params.id,
        show: true,
        title: "Anotações",
        description: "Job J",
        layout: "Note",
      };

    },
    openAttach() {
      this.modal = {
        id: this.id || this.$route.params.id,
        show: true,
        title: "Anexar arquivos",
        description: "Job J",
        layout: "Attach",
      };

    },
    openAttendance() {
      this.modal = {
        id: this.id || this.$route.params.id,
        show: true,
        title: "Atendimentos",
        description: "Job J",
        layout: "Attendance",
      };

    },
    jobToGD() {
      this.loader = true
      this.TAKE_JOB({ idJob: this.job.id, idAdmin: this.user.id_funcionario }).then(() => {
        this.loader = false;
        this.getJob()
      }).catch(() => this.loader = false)
    },
    finalizarJob() {
      if (confirm("Deseja finalizar este job?")) {
        this.loader = true
        this.FINALIZACAO({ ID: this.job.id, data: this.finalizacao }).then(() => {
          this.loader = false; 
          this.modalFinalizacao.show = false;
          this.finalizacao = { dh_fechamento_cliente: new Date(), aceite_cliente: false }
          this.getJob();
        }).catch(() => this.loader = false)
      }
    }
  },
  mounted() {
    this.getJob();
    this.getGD();
    if (window.location.pathname != "/funcionario/jobs") document.title = `Job ${this.id || this.$route.params.id}`;
  },
  computed: {
    ...mapGetters("user", ["user"]),
    campos_registro() {
      return (this.job.mapa_campos || []).filter(m => m.etapa == "registro" && this.job[m.nome])
    },
    campos_encerramento() {
      return (this.job.mapa_campos || []).filter(m => m.etapa == "encerramento" && this.job[m.nome])
    },
  },
};
</script>
<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.job
  .title span
    color: $red
    font-size: 18px
    white-space: nowrap
    font-weight: bold
    
  .panel-right
    button
      margin-left: 12px
      margin-bottom: 12px
    select
      height: 36px
      width: 200px
    .save
      background: $green
  .changeGD
    @media (max-width: $small)
      width: 100%
      padding: 14px 0
    .save
      margin-bottom: 0
  .divulgacao
    margin-top: 40px
    padding-top: 34px
    border-top: 1px solid $white-1
    color: $font-color
    label
      @include label
    .title
      font-size: 22px
      color: $purple
    .numbers
      margin-top: 30px
  .nao-faturavel
    padding: 20px
  .sla-item
    margin-bottom: 16px
  .resaloc
    label
      color: $purple
    color: $orange
    max-width: 600px
    padding: 0 30px
    padding-bottom: 30px
    font-size: 14px
    button
      margin: 0
      margin-top: 30px
  .adicionais
    background: rgba(#eee,.4)
    border-radius: 12px
    margin-right: 10px
    padding: 4px 14px
    @media (max-width: $small) 
      margin-bottom: 20px
  .modalFinalizacao
    padding: 20px 30px
    label
      @include label
    button
      margin-top: 30px
      margin-left: 0
</style>
<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.job {
  padding: 32px 35px;
  box-shadow: $shadow;
  background: white;
  border-radius: 29px;
  font-size: 19px;

  .title {
    font-size: 26px;
    font-weight: 400;
    margin-bottom: 33px;
    margin-right: 12px;

    .button {
      /*  min-width: 180px; */
      margin-right: 4px;
      height: 35px;

    }

    .controls {
      margin-left: 30px;

      @media (max-width: $small) {
        margin-left: 0px;

        button {
          margin-bottom: 20px;
        }
      }
    }

    @media (max-width: $large) {
      padding-bottom: 15px;
    }

    strong {
      color: $supporter-1;
    }

  }

  .associate {
    margin-left: 10px;
  }

  .buttons {
    @media (max-width: $small) {
      margin-top: 27px;
      margin-bottom: 10px;
    }
  }

  .buttons-2 {
    padding-top: 35px;

    @media (max-width: $small) {
      margin-top: 27px;
      margin-bottom: 10px;

      button {
        margin-bottom: 20px;
      }
    }
  }

  &-loader {
    margin-top: 20%;
    background: white;
  }

  .sla {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 30px;

    &-content {
      margin-top: 7px;
    }

    &-status {
      margin-left: 10px;
    }
  }

  .perfil {
    img {
      width: 85px;
      height: 85px;
      margin-right: 8px;
    }
  }

  .info {
    margin-top: 25px;
    padding-top: 24px;
    border-top: 1px solid $white-1;

    div {
      margin-bottom: 30px;
      margin-right: 20px
    }
  }

  .margin-bottom {
    @media (max-width: $large) {
      margin-bottom: 30px;
    }
  }

  .comp {
    .container {
      margin-top: 6px;
      max-height: 75px;
      padding: 4px;
      overflow: auto;
      line-height: 20px;
    }

    @media (max-width: $large) {
      margin: 20px 0px;
    }
  }

  .status {
    color: $white-7;
    font-size: 12px;
    list-style: none;

    li {
      margin-left: 40px;

      @media (max-width: $medium) {
        margin-left: 10px;
      }
    }

    .active {
      color: $green-9;
      border-bottom: 2px solid $green-9;
      height: 30px;
      font-weight: bold;
    }
  }

  .label {
    color: $purple;
    font-size: 16px;
    font-weight: 300;

    strong {
      color: $gray-7;
      text-transform: capitalize;
    }
  }

  .data {
    padding-top: 45px;
    padding-bottom: 46px;
    border-bottom: 1px solid $white-1;

    label {
      margin-bottom: 8px;
    }

    .grid-2-g {
      @media (max-width: $small) {
        margin-bottom: 30px;
      }
    }

    .ps {
      color: $gray-6;
      background: $white-8;
      padding: 8px 14px;
      border-radius: 5px;
      margin-left: 30px;
    }

    .row-2 {
      margin-top: 32px;
    }
  }

  .white {
    box-shadow: none;
    margin-right: 9px;
  }

  .openmap {
    @media (max-width: $medium) and (min-width: $small) {
      margin-top: 38px;
    }

    @media (max-width: $small) {
      margin-top: 38px;
      justify-content: center;

      button {
        width: 100%;
      }
    }

    @media (min-width: $small) and (max-width: $large) {
      margin-top: 25px;
      justify-content: flex-end;
    }
  }

  .button-green-go,
  .button-blue-go,
  .button-red-go {
    margin-left: 10.5px;
  }

  .button-black-go {
    display: flex;
    flex-direction: row;
    align-items: center;

    i {
      margin-right: 6px;
      font-size: 20px;
      transform: rotate(90deg);
    }
  }

  @media (max-width: $small) {
    .button-gold-2 {
      margin-top: 10px;
    }
  }

  .problem {
    margin-top: 21px;
  }
}
</style>
